import React from 'react';

const cartContext = React.createContext({
    items: [],
    additem: (item) => {},
    removeItem: (id) => {},
    finditem: (id) => {}
});

export default cartContext;